import React, { useState, useEffect } from "react";
import { webTitle } from "@/config/config";
import HomeLogo from "@/assets/loginLogo.svg";
import UserPanel from "@/Components/PageTop/UserPanel";
import ImageType from "./ShowImgType";
import TableType from "./ShowTableType";
import { Space, Radio, Result, Popconfirm, Spin, message, Pagination, Form, Modal, Button, Input } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import PageTitle from "@/Components/PageTop/PageTitle";
import { projects, delProject } from "@/services/common";
import { useNavigate } from 'react-router-dom';
import CreateProject from "@/Components/CreateModal/CreateProjectModal";
import '@/less/var.less';
import userInfo from "@/Components/user";
import PageTop from '../PageTop';
import { radomPics } from "@/config/const";
import { createProject, createFlow } from "@/services/common";

const Component = (props: any) => {
  const [showType, setShowType] = useState<string>("img");
  const [count, setCount] = useState<any>(null);
  const [source, setSource] = useState<any>(null);
  const [curInfo, setCurInfo] = useState<any>(null);
  const [curPage, setCurPage] = useState(1);
  const [perPage, setPerPage] = useState(6);
  const [curType, setCurType] = useState<string>("create");
  const [createModalStatus, setCreateModalStatus] = useState(false);
  const [projectName, setProjectName] = useState("未命名项目");
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const loadData = () => {
    projects(
      {
        // owner_id: userInfo.id,
        owner_id: 1,
        page: curPage,
        perPage,
      },
      userInfo.access_token
      // token
    ).then((r) => {
      // console.log("rrrrrrrrrr", r.data);
      setSource(r.data.data);
      setCount(r.data.count);
    });
  };
  useEffect(() => {
    loadData();
  }, [curPage, perPage]);

  const del_confirm = (id: any) => {
    delProject(id, userInfo.access_token)
      .then((r) => {
        if (r.status === 200) {
          message.success("项目已删除!");
          loadData();
        } else {
          message.error("项目删除失败!");
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          message.warning("请先删除此项目包含的流程");
        } else {
          message.error("操作失败，请重试");
        }
      });
  };
  const createBlankProject = () => {
    setOpen(false);
    const subData = {
      name: projectName,
      thumbnail_url: radomPics(),
      // owner_id: userInfo.id,
      owner_id: 1,
    }
    createProject(subData, userInfo.access_token).then((r) => {
      if (r.status === 200) {
        console.log("rrr:", r.data);
        message.success("项目创建成功！");
        const flowData = {
          name: "未命名流程",
        }
        createFlow(r.data.id, flowData, userInfo.access_token).then((r: any) => {
          if (r.status === 200) {
            navigate(`/project/${r.data.project_id}/flow/${r.data.id}/setting`)
            // message.success("流程创建成功！");
            // loadData();
          } else {
            message.error("流程创建失败！");
          }
        });
      } else {
        message.error("项目创建失败！");
      }
    });
  }

  return (
    <>
      <PageTop mainContent={

        <div>
        </div>
      } />
      <div style={{ width: "80%", marginLeft: "10%", marginTop: "25px" }}>

        <PageTitle
          title={
            <div
              className="button_new2"
              onClick={() => {
                // setCurType("create");
                // setCreateModalStatus(true);
                setOpen(true);
              }}
              style={{ marginLeft: "0.5rem" }}
            >
              + 新建项目
            </div>
          }
          extra={
            <Space>

              <ul className="listType" style={{ marginLeft: '2rem', marginRight: "0.5rem" }}>
                <li
                  className={`${showType === "img" ? "active" : ""}`}
                  onClick={() => setShowType("img")}
                >
                  <div className={`icon imgType${showType === "img" ? "" : " off"}`} />
                </li>
                <li
                  className={`${showType === "table" ? "active" : ""}`}
                  onClick={() => setShowType("table")}
                >
                  <div className={`icon tableType${showType === "table" ? "" : " off"}`} />
                </li>
              </ul>

            </Space>
          }
        />
      </div>
      <Modal
        title={<div className="t2">创建空白项目：</div>}
        open={open}
        // onOk={handleOk}
        onCancel={() => setOpen(false)}
        maskClosable={false}
        footer={
          <Space>
            <Button type="primary" onClick={createBlankProject}>
              {/* <Button type="primary"> */}
              <CheckOutlined />
            </Button>
            <Button onClick={() => setOpen(false)}>
              <CloseOutlined />
            </Button>
          </Space>
        }
      >
        <Form>
          <Form.Item label="项目名称">
            <Input
              value={projectName}
              onChange={(e: any) => {
                setProjectName(e.target.value);
              }}
            />
          </Form.Item>
        </Form>
      </Modal>
      <div className="indexShow">
        {source ? (
          <div className="indexshowMain" style={{ width: "80%" }}>

            {count > 0 ? (
              showType === "img" ? (
                <ImageType
                  source={source}
                  del_confirm={del_confirm}
                  loadData={loadData}
                  setCurInfo={setCurInfo}
                  setStatus={setCreateModalStatus}
                  setCurType={setCurType}
                />
              ) : (
                <TableType
                  source={source}
                  del_confirm={del_confirm}
                  loadData={loadData}
                  setCurInfo={setCurInfo}
                  setStatus={setCreateModalStatus}
                  setCurType={setCurType}
                  userInfo={userInfo}
                />
              )
            ) : (
              <div className="noResults mt2">
                <Result
                  status="info"
                  title={<div className="t2 w">暂时没有项目数据，请添加项目！</div>}
                ></Result>
              </div>
            )}
            <div className="index_pageSep">
              <Pagination
                current={curPage}
                total={count}
                pageSize={perPage}
                hideOnSinglePage={true}
                onChange={(p: number) => setCurPage(p)}
                showSizeChanger={false}
              />
            </div>
          </div>
        ) : (
          <div className="loadingArea">
            <Spin />
          </div>
        )}

        <CreateProject
          status={createModalStatus}
          setStatus={setCreateModalStatus}
          userInfo={userInfo}
          loadData={loadData}
          type={curType}
          source={curInfo}
        />
      </div>
    </>
  );
};

export default Component;
